import type { ColumnDef } from "@tanstack/react-table";
import { Check, ThumbsDown, ThumbsUp, Trash } from "lucide-react";

import { DataTableCenteredCell } from "@/shared/ui/DataTable";
import { formatDate } from "@/shared/lib/utils";
import { SortButton } from "@/features/SortButton/SortButton";
import { CandidateStatusDropdown } from "@/widgets/CandidateStatusModal";
import { Button } from "@/shared/ui/button";
import { useVerdictContacts } from "@/entities/candidate/api";
import type { Candidate } from "@/entities/candidate/model";
import { CandidateStatus } from "@/entities/candidate/model";

export const CandidatesColumns: ColumnDef<Candidate>[] = [
  {
    accessorKey: "tgNickname",
    header: () => <DataTableCenteredCell>Никнейм</DataTableCenteredCell>,
    cell: ({ row }) => (
      <DataTableCenteredCell>
        {row.getValue("tgNickname") || "NA"}
      </DataTableCenteredCell>
    ),
  },
  {
    accessorKey: "createdAt",
    header: () => (
      <DataTableCenteredCell>
        <SortButton title="Время подачи" sort="createdAt" />
      </DataTableCenteredCell>
    ),
    cell: ({ row }) => (
      <DataTableCenteredCell>
        {row.original.updatedAt
          ? formatDate(new Date(row.original.updatedAt))
          : "N/A"}
      </DataTableCenteredCell>
    ),
  },
  {
    accessorKey: "candidateStatus",
    header: () => <CandidateStatusDropdown />,
    cell: ({ row }) => (
      <DataTableCenteredCell>
        {row.original.status === "pending"
          ? "В ожидании"
          : row.original.status === "approved"
            ? "Одобрено"
            : "Отклонен"}
      </DataTableCenteredCell>
    ),
  },
  {
    id: "actions2",
    header: () => <DataTableCenteredCell>Действия</DataTableCenteredCell>,
    cell: ({ row }) => {
      const { mutateAsync, isPending } = useVerdictContacts();
      const { _id: id, status } = row.original;

      const renderStatus = () => {
        switch (status) {
          case CandidateStatus.Approved:
            return (
              <div className="flex items-center gap-1 text-green-600">
                <ThumbsUp className="h-4 w-4" />
                <span>Одобрен</span>
              </div>
            );
          case CandidateStatus.Rejected:
            return (
              <div className="flex items-center gap-1 text-red-600">
                <ThumbsDown className="h-4 w-4" />
                <span>Отклонён</span>
              </div>
            );
          case CandidateStatus.Pending:
          default:
            return (
              <div className="flex flex-row gap-2">
                <Button
                  variant="outline"
                  onClick={() =>
                    mutateAsync({ id, verdict: CandidateStatus.Approved })
                  }
                  disabled={isPending}
                >
                  <Check />
                </Button>
                <Button
                  variant="destructive"
                  onClick={() =>
                    mutateAsync({ id, verdict: CandidateStatus.Rejected })
                  }
                  disabled={isPending}
                >
                  <Trash />
                </Button>
              </div>
            );
        }
      };

      return <DataTableCenteredCell>{renderStatus()}</DataTableCenteredCell>;
    },
  },
];
